var selectioCtrl = document.querySelector(".store-selection-ctrl-mobile"),
  selectionList = document.querySelector(
    ".store-selecetion-popup-mobile .store-selection-list-country"
  ),
  selectionListItems = document.querySelectorAll(
    ".store-selecetion-popup-mobile .store-selection-list-item-mobile"
  ),
  storeName = document.querySelector("#store--name-country"),
  storeCurrency = document.querySelector(".store-currency"),
  storeSelectionButton = document.querySelector(
    ".store-selecetion-popup-mobile .store-selection-popup--button"
  ),
  storeURL = "self",
  visitingFrom = "AUS",
  visitingCur = "AUD",
  visitingflag = "";
(modalClose = document.querySelector(
  ".store-selecetion-popup-mobile .store-selection-popup--close"
)),
  (flagClass = "");

var storeChecked = localStorage.getItem("storeChecked");
var urlParam = location.search.indexOf("redirectFrom");
if (storeChecked || urlParam != -1) {
  document.querySelector(".store-selecetion-popup-mobile").style.display =
    "none";
}
if (urlParam != -1) {
  var queryString = window.location.search;
  var urlParams = new URLSearchParams(queryString);
  let store = urlParams.get("redirectFrom");
  store = store.replace("%20", "");
  localStorage.setItem("visitingFrom", store);
  localStorage.setItem("storeChecked", "true");
}
function rebuildSelectionList(current) {
  selectionListItems.forEach(function (el) {
    if (current == el) {
      el.style.display = "none";
    } else {
      el.style.display = "block";
    }
  });
}

function showVisitingFromMobile() {
  var text = localStorage.getItem("visitingFrom");
  if (text != null) {
    document
      .querySelectorAll(".visiting-from--text .current-country")
      .forEach(function (el) {
        el.classList.remove(el.classList.item(1));
      });
    switch (text) {
      case "Australia":
        document
          .querySelectorAll(".visiting-from--text .current-country")
          .forEach(function (el) {
            el.classList.add("au");
          });
        document
          .querySelectorAll(".visiting-from--text .current-country")
          .forEach(function (el) {
            el.innerText = "AUS";
          });
        document.querySelectorAll(".store-country").forEach(function (el) {
          el.classList.add("au");
        });
        document.querySelectorAll(".store-country").forEach(function (el) {
          el.innerText = "Australia";
        });
        $(".countrynameselect").html("Australia");
        storeSelectionButton.innerText = `Go to New Zealand`;
        $(".store-selection-list-item-mobile.au").hide();
        visitingCur = "AUD";
        visitingflag = "aud";
        break;
      case "United Kingdom":
        document
          .querySelectorAll(
            ".store-selecetion-popup .visiting-from--text .current-country"
          )
          .forEach(function (el) {
            el.classList.add("gbp");
          });
        document
          .querySelectorAll(
            ".store-selecetion-popup .visiting-from--text .current-country"
          )
          .forEach(function (el) {
            el.innerText = "UK";
          });
        document
          .querySelectorAll(".store-selecetion-popup .store-country")
          .forEach(function (el) {
            el.classList.add("gbp");
          });
        document
          .querySelectorAll(".store-selecetion-popup .store-country")
          .forEach(function (el) {
            el.innerText = "United Kingdom";
          });
        $(".store-selection-list-item-mobile.gbp").hide();
        visitingCur = "GBP";
        $(".countrynameselect").html("United Kingdom");
        break;
      case "New Zealand":
        document
          .querySelectorAll(".visiting-from--text .current-country")
          .forEach(function (el) {
            el.classList.add("nz");
          });
        document
          .querySelectorAll(".visiting-from--text .current-country")
          .forEach(function (el) {
            el.innerText = "NZ";
          });
        document.querySelectorAll(".store-country").forEach(function (el) {
          el.classList.add("nz");
        });
        document.querySelectorAll(".store-country").forEach(function (el) {
          el.innerText = "New Zealand";
        });
        $(".store-selection-list-item-mobile.nz").hide();
        storeSelectionButton.innerText = `Go to New Zealand`;
        visitingCur = "NZD";
        visitingflag = "nzd";
        $(".countrynameselect").html("New Zealand");
        break;
      case "International":
        document
          .querySelectorAll(".visiting-from--text .current-country")
          .forEach(function (el) {
            el.classList.add("int");
          });
        document
          .querySelectorAll(".visiting-from--text .current-country")
          .forEach(function (el) {
            el.innerText = "INT";
          });
        document.querySelectorAll(".store-country").forEach(function (el) {
          el.classList.add("int");
        });
        document.querySelectorAll(".store-country").forEach(function (el) {
          el.innerText = "International";
        });
        $(".store-selection-list-item-mobile.int").hide();
        visitingCur = "USD";
        visitingflag = "int";
        storeSelectionButton.innerText = `Go to International`;
        $(".countrynameselect").html("International");

        break;
      case "United States":
        document
          .querySelectorAll(".visiting-from--text .current-country")
          .forEach(function (el) {
            el.classList.add("usd");
          });
        document
          .querySelectorAll(".visiting-from--text .current-country")
          .forEach(function (el) {
            el.innerText = "USA";
          });
        document.querySelectorAll(".store-country").forEach(function (el) {
          el.classList.add("usd");
        });
        document.querySelectorAll(".store-country").forEach(function (el) {
          el.innerText = "United States";
        });
        $(".store-selection-list-item-mobile.us").hide();
        visitingCur = "USD";
        visitingflag = "usd";
        $(".countrynameselect").html("United States");

        storeSelectionButton.innerText = `Go to United States`;
        break;
      case "Singapore":
        document
          .querySelectorAll(".visiting-from--text .current-country")
          .forEach(function (el) {
            el.classList.add("sgd");
          });
        document
          .querySelectorAll(".visiting-from--text .current-country")
          .forEach(function (el) {
            el.innerText = "SGP";
          });
        document.querySelectorAll(".store-country").forEach(function (el) {
          el.classList.add("sgd");
        });
        document.querySelectorAll(".store-country").forEach(function (el) {
          el.innerText = "Singapore";
        });
        storeSelectionButton.innerText = `Go to Singapore`;

        $(".store-selection-list-item-mobile.sgd").hide();
        visitingCur = "SGD";
        visitingflag = "sgd";
        $(".countrynameselect").html("Singapore");
        break;
        case "The Netherlands":
        document
          .querySelectorAll(".visiting-from--text .current-country")
          .forEach(function (el) {
            el.classList.add("euro");
          });
        document
          .querySelectorAll(".visiting-from--text .current-country")
          .forEach(function (el) {
            el.innerText = "EUR";
          });
        document.querySelectorAll(".store-country").forEach(function (el) {
          el.classList.add("euro");
        });
        document.querySelectorAll(".store-country").forEach(function (el) {
          el.innerText = "Netherlands";
        });
        storeSelectionButton.innerText = `Go to Netherlands`;

        $(".store-selection-list-item-mobile.euro").hide();
        visitingCur = "EUR";
        visitingflag = "euro";
        $(".countrynameselect").html("Netherlands");
        break;  
        case "Europe":
        document
          .querySelectorAll(".visiting-from--text .current-country")
          .forEach(function (el) {
            el.classList.add("europe");
          });
        document
          .querySelectorAll(".visiting-from--text .current-country")
          .forEach(function (el) {
            el.innerText = "EUR";
          });
        document.querySelectorAll(".store-country").forEach(function (el) {
          el.classList.add("europe");
        });
        document.querySelectorAll(".store-country").forEach(function (el) {
          el.innerText = "Europe";
        });
        storeSelectionButton.innerText = `Go to Europe`;

        $(".store-selection-list-item-mobile.europe").hide();
        visitingCur = "EUR";
        visitingflag = "europe";
        $(".countrynameselect").html("Europe");
        break; 
    }
  } else {
    document
      .querySelectorAll(".visiting-from--text .current-country")
      .forEach(function (el) {
        el.classList.add("usd");
      });
    document
      .querySelectorAll(".visiting-from--text .current-country")
      .forEach(function (el) {
        el.innerText = "USA";
      });
    document.querySelectorAll(".store-country").forEach(function (el) {
      el.classList.add("usd");
    });
    document.querySelectorAll(".store-country").forEach(function (el) {
      el.innerText = "United States";
    });
    $(".countrynameselect").html("United States");

    $(".store-selection-list-item-mobile.us").hide();
    visitingCur = "USD";
    visitingflag = "usd";
  }
}

function showSelectionPopupMobile() {
  document.querySelector(".store-selecetion-popup-mobile").style.display =
    "flex";
}

selectioCtrl.addEventListener("click", function () {
  if (selectionList.classList.contains("is-open")) {
    selectionList.classList.remove("is-open");
  } else {
    selectionList.classList.add("is-open");
  }
});

selectionListItems.forEach(function (item) {
  item.addEventListener("click", function () {
    storeURL = item.getAttribute("data-link");
    selectionList.classList.remove("is-open");
    storeName.classList = "";
    flagClass = item.classList[1];
    storeName.innerText = item.innerText;
    storeName.classList.add("store--name", flagClass);
    visitingFrom = item.innerText;
    visitingCur = item.getAttribute("data-currency");
    visitingflag = item.getAttribute("data-flag");
    storeSelectionButton.innerText = `Go to ${item.innerText}`;
    storeCurrency.innerText = `${visitingCur}`;
    rebuildSelectionList(item);
    storeName.classList.add(visitingflag);
    console.log(flagClass);
  });
});

storeSelectionButton.addEventListener("click", function () {
  // if (storeURL == "self") {
  //   document.querySelector(".store-selecetion-popup-mobile").style.display = "none";
  //   localStorage.setItem("storeChecked", "true");
  //   localStorage.setItem("visitingFrom", visitingFrom);
  //   showVisitingFrom();
  // } else {
  //   window.location.href = `${storeURL}?redirectFrom=${visitingFrom}`;
  // }
  visitingFrom = $('#store--name').html().trim();
  if (visitingCur == "AUD" || visitingCur == "NZD") {
    console.log(visitingCur);
    localStorage.setItem("storeChecked", "true");
    localStorage.setItem("visitingFrom", visitingFrom);
    window.location.href = `https://bhumi.com.au/?redirectFrom=${visitingFrom}`;
  } else if (visitingCur == "GBP") {
    console.log(visitingCur);
    localStorage.setItem("storeChecked", "true");
    localStorage.setItem("visitingFrom", visitingFrom);
    window.location.href = `https://www.bhumiorganic.co.uk/?redirectFrom=${visitingFrom}`;
  }else if (visitingCur == "EUR") {
    console.log(visitingCur);
    localStorage.setItem("storeChecked", "true");
    localStorage.setItem("visitingFrom", visitingFrom);
    window.location.href = `https://www.bhumi-organic.com/?redirectFrom=${visitingFrom}`;
  } else {
    document.querySelector(".store-selecetion-popup-mobile").style.display =
      "none";
    localStorage.setItem("storeChecked", "true");
    localStorage.setItem("visitingFrom", visitingFrom);
    $(".currency-selector-auto select").val(visitingCur);
    $(".currency-selector-auto form").submit();
  }
});

modalClose.addEventListener("click", function () {
  localStorage.setItem("storeChecked", "true");
  localStorage.setItem("visitingFrom", "United States");
  document.querySelector(".store-selecetion-popup-mobile").style.display =
    "none";
});

$(document).ready(function () {
  
  $(".openpopupmobile").click(function () {
    showSelectionPopupMobile();
  });
});
document.addEventListener('showVisitingFromMobile', () => {
    showVisitingFromMobile();
});